import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';

// HTTP connection to the API
const httpLink = createHttpLink({
	uri: process.env.VUE_APP_GRAPHQL,
});

const cache = new InMemoryCache();

// eslint-disable-next-line import/prefer-default-export
export const apolloClient = new ApolloClient({
	link: httpLink,
	cache,
});
